export const REACTEVENTS = {
    ORDER_CREATE: 'order_created',
    ORDER_ACCEPT: 'order_accepted',
    ORDER_DECLINE: 'order_declined',
    ORDER_UPDATE: 'order_updated',
    CASH_COLLECT: 'cash_collect',
    TABLE_EVENT: 'table_notification',
    AUTOACCEPT_SOUND: 'auto_accept_notification'
} 